import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaColors, YodaFontSize, YodaFontWeight, YodaJustifyContent, YodaSpacing } from 'yoda-ui/yodaTheme';

export const sideContainerStyle = {
  root: {
    width: '100%',
    border: `1px solid ${YodaColors.neutralGrey3}`,
  },
  firstBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: YodaJustifyContent.spaceBetween,
    backgroundColor: YodaColors.transparent,
    padding: YodaSpacing.medium,
  },
  title: {
    fontSize: YodaFontSize.small,
    fontWeight: '600',
    marginBottom: YodaSpacing.xxSmall,
  },
  cepTitle: {
    fontSize: YodaFontSize.medium,
    fontWeight: YodaFontWeight.medium,
    marginBottom: YodaSpacing.medium,
    lineHeight: '1.5',
  },
};

export const sideContainerStyleInnerBox: SxProps<Theme> = () => ({
  '& > div': {
    marginBottom: YodaSpacing.small,
  },

  '& > div:last-child': {
    marginBottom: YodaSpacing.none,
  },
});
